import {Controller} from "@hotwired/stimulus"
import consumer from '../channels/consumer';

export default class extends Controller {
    static targets = ['template', 'messages', 'input']

    connect() {
        if (document.documentElement.hasAttribute('data-turbo-preview')) {
            return;
        }

        this.subscription = consumer.subscriptions.create({channel: 'ChatChannel'}, {
            connected: this.onConnected.bind(this),
            disconnected: this.onDisconnected.bind(this),
            received: this.onReceived.bind(this),
        })

        this.inputTarget.addEventListener("keydown", this.handleKeydown.bind(this))
    }

    disconnect() {
        if (this.subscription) {
            this.subscription.unsubscribe()
            this.subscription = null
        }

        this.messagesTarget.innerHTML = ''
        this.inputTarget.removeEventListener("keydown", this.handleKeydown.bind(this))
    }

    speak(message) {
        this.subscription.perform('speak', {message: message})
    }

    callCharacter(character) {
        this.subscription.perform('request', {character: character})
    }

    send() {
        const message = this.inputTarget.value.trim()
        if (message && this.subscription) {
            this.speak(message)
            this.inputTarget.value = ''
        }
    }

    callHerbert() {
        this.callCharacter("herbert")
    }

    callLilly() {
        this.callCharacter("lilly")
    }

    onConnected() {
        console.log('Chat WebSocket connected')
    }

    onDisconnected() {
        console.log('WebSocket disconnected')
    }

    onReceived(data) {
        if (data.type === 'history') {
            data.messages.forEach((message) => {
                this.appendMessage(message)
            })
        } else {
            this.appendMessage(data)
        }
    }

    appendMessage(message) {
        const messageElement = this.templateTarget.content.cloneNode(true)

        messageElement.querySelector('[data-user]').textContent = message.user
        messageElement.querySelector('[data-message]').textContent = message.message
        messageElement.querySelector('[data-timestamp]').textContent = new Date(message.timestamp).toLocaleString()
        messageElement.querySelector('[data-image]').src = message.avatar

        this.messagesTarget.appendChild(messageElement)
        this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
    }

    handleKeydown(event) {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault()
            this.send()
        }
    }
}

